rdefine('app/formular/collections/Choice',['backbone','app/formular/models/ChoiceModel'],function(Backbone,Model) {
    return Backbone.Ribs.Collection.extend({
        model:Model
    });
});